import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

instance.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      router.push({ name: "UserLogin" });
      localStorage.removeItem("token");
      localStorage.removeItem("user");

    }
    return Promise.reject(error);
  }
);

export default instance;
